import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '@offertify/api-client';
import { useAuth } from '../contexts/AuthContext';

type Delivery = { offerta_id: string; numero?: string; titolo?: string; node_id?: string; stato: string; inviata_at?: string; errore?: string; richiesta_at?: string };
const labels: Record<string, string> = { da_inviare: 'Da inviare', queued: 'In coda', sending: 'Invio in corso · esito da verificare se interrotto', sent: 'Inviata alla tabella MEPA', failed: 'Errore di invio', uncertain: 'Esito da verificare' };

export default function MepaOffersPanel({ offerId, standalone = false }: { offerId?: string; standalone?: boolean }) {
  const [filter, setFilter] = useState('');
  const [page, setPage] = useState(1);
  const { tenant } = useAuth();
  const query = useQuery({
    queryKey: ['mepa-offerte', tenant?.id, offerId, filter, page],
    queryFn: async () => {
      const response = await getApiClient().client.get(offerId ? `/mepa/offerte/${offerId}` : '/mepa/offerte', { params: { stato: filter || undefined, page } });
      return offerId ? { data: [response.data as Delivery], total: 1 } : response.data as { data: Delivery[]; total: number };
    },
    refetchInterval: 15000,
  });
  const Container = standalone ? 'section' : 'details';
  return <Container className="rounded-lg border border-gray-200 bg-white p-4">
    {!standalone && <summary className="cursor-pointer font-medium">Invio offerte approvate a MEPA / AS400</summary>}
    <p className="mt-3 text-sm text-gray-600">L’invio deposita una copia dell’offerta nella tabella di scambio. La creazione dell’ordine nel gestionale è un passaggio successivo.</p>
    {!offerId && <label className="mt-3 block text-sm">Stato invio <select className="ml-2 rounded border p-2" value={filter} onChange={e => { setFilter(e.target.value); setPage(1); }}>
      <option value="">Tutti</option>{Object.entries(labels).map(([value, text]) => <option key={value} value={value}>{text}</option>)}
    </select></label>}
    {query.isLoading && <p role="status">Caricamento invii…</p>}
    {query.isError && <p role="alert">Impossibile caricare lo stato degli invii.</p>}
    <ul className="mt-3 divide-y">{query.data?.data.map(row => <li key={row.offerta_id} className="py-2 text-sm">
      {!offerId && <Link className="mr-3 text-primary-600 underline" to={`/offers/${row.offerta_id}/edit`}>{row.numero}</Link>}
      {row.titolo && <span className="mr-3 text-gray-600">{row.titolo}</span>}
      <span>{labels[row.stato] || row.stato}</span>
      {row.node_id && <span className="ml-3 text-gray-500">Nodo {row.node_id}</span>}
      {row.richiesta_at && <span className="ml-3 text-gray-500">Richiesta: {new Date(row.richiesta_at).toLocaleString('it-IT')}</span>}
      {row.inviata_at && <span className="ml-3">{new Date(row.inviata_at).toLocaleString('it-IT')}</span>}
      {row.errore && <p role="alert" className="text-red-700">{row.errore}</p>}
    </li>)}</ul>
    {query.data?.data.length === 0 && <p className="mt-3 text-sm">Nessuna offerta per questo filtro.</p>}
    {!offerId && query.data && query.data.total > 20 && <div className="mt-3 flex items-center gap-3 text-sm">
      <button type="button" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Precedente</button><span>Pagina {page}</span>
      <button type="button" disabled={page * 20 >= query.data.total} onClick={() => setPage(p => p + 1)}>Successiva</button>
    </div>}

  </Container>;
}
